import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getProduct, getSettings, recordScan } from "@/lib/data";
import { buildBlocks } from "@/lib/i18n";
import { Spinner } from "@/components/Spinner";
import { NotFound, Logo, LanguageBlock, JumpChips, ContactFooter, Discontinued } from "@/pages/PublicParts";

export default function PublicProduct() {
  const [params] = useSearchParams();
  const id = (params.get("id") || "").trim();
  const [state, setState] = useState({ loading: true, product: null, settings: null });

  useEffect(() => {
    let alive = true;
    setState({ loading: true, product: null, settings: null });
    const warn = (fallback) => (e) => { console.error(e); return fallback; };
    Promise.all([getProduct(id).catch(warn(null)), getSettings().catch(warn({}))]).then(([product, settings]) => {
      if (!alive) return;
      setState({ loading: false, product, settings });
      if (product) recordScan(product.id);
    });
    return () => { alive = false; };
  }, [id]);

  if (state.loading) return <div className="pub-root"><Spinner full /></div>;
  if (!state.product) return <NotFound logoUrl={state.settings?.logoUrl} />;

  const p = state.product;
  const blocks = buildBlocks(p, state.settings || {});
  if (p.status === "hidden") return <Discontinued product={p} settings={state.settings} contactLabel={blocks[0].headings.contact} />;
  if (p.productName) document.title = `${p.brandName ? p.brandName + " · " : ""}${p.productName}`;

  return (
    <div className="pub-root min-h-screen bg-[#F8FAFC]" data-testid="public-product-page">
      <main className="pub-fade mx-auto max-w-xl px-4 pb-10 pt-5 sm:px-6">
        <Logo url={state.settings?.logoUrl} />
        {p.imageUrl && (
          <div className="mt-5 overflow-hidden rounded-lg border border-slate-200 bg-white">
            <img
              data-testid="public-product-image"
              src={p.imageUrl}
              alt={p.productName}
              className="mx-auto aspect-square w-full max-h-[420px] object-contain p-4"
            />
          </div>
        )}
        {blocks.length > 1 && <JumpChips blocks={blocks} />}
        {blocks.map((b, i) => <LanguageBlock key={b.code} block={b} product={p} first={i === 0} />)}
        <ContactFooter text={p.companyContact} label={blocks[0].headings.contact} />
      </main>
    </div>
  );
}
